import { Injectable } from "@angular/core";
import { Headers, Http, RequestOptions, Response } from "@angular/http";
import { AuthenticationService } from "../authentication.service";
import { EnvironmentService } from "../index";
import { BehaviorSubject, Observable } from "rxjs";
import "rxjs/add/operator/map";
import "rxjs/add/operator/catch";
import { IntervalMatch } from "../../_models/intervalMatch";
import { Customer } from "../../_models/customer";
import { Car } from "../../_models/car";

@Injectable()
export class ServiceIntervalMatchesService {
    private baseUrl: string = this.environmentService.getBaseURL() + "/api";
    constructor(
        private http: Http,
        private authenticationService: AuthenticationService,
        private environmentService: EnvironmentService
    ) { }

    getAll(did): Observable<IntervalMatch[]> {
        let matches$ = this.http
            // new change -- here api in pass dealer id
            .get(
                `${this.baseUrl}/interval-matches?dealer=${did}&populate=car&populate=customer`,
                this.makeHeaders()
            )
            .map(mapIntervalMatches)
            .catch(handleError);
        return matches$;
    }
    getAllWitouthData(did): Observable<IntervalMatch[]> {
        let matches$ = this.http
            // new change -- here api in pass dealer id
            .get(
                `${this.baseUrl}/interval-matches?dealer=${did}`,
                this.makeHeaders()
            )
            .map(mapIntervalMatches)
            .catch(handleError);
        return matches$;
    }

    delete(id: string) : Observable<Response>{
        return this.http
          .delete(`${this.baseUrl}/interval-matches/${id}`, this.makeHeaders())
            .map((res:Response) => res.json()) // ...and calling .json() on the response to return data
            .catch((error:any) => Observable.throw(error.json().error || 'Server error')); //...errors if any
      }

    private makeHeaders(): RequestOptions {
        let headers = new Headers();

        headers.append("Authorization", this.authenticationService.getToken());
        headers.append("Content-Type", "application/json");
        headers.append("charset", "UTF-8 ");
        headers.append("Accept", "application/json");

        let options = new RequestOptions({ headers: headers });
        return options;
    }
}

function mapAny(response: Response): any[] {
    return response.json().map(toAny);
}

function mapMatch(response: Response): IntervalMatch {
    var json = response.json();
    return toIntervalMatch(json);
}

function mapIntervalMatches(response: Response): IntervalMatch[] {
    // uncomment to simulate error:
    // throw new Error('ups! Force choke!');
    //console.log(response);
    return response.json().map(toIntervalMatch);
}

function toAny(r: any): any {
    let object: any;
    object = r;
    return object;
}

function toIntervalMatch(r: any): IntervalMatch {
    let match = <IntervalMatch>{
        _id: r._id,
        serviceEstimate: r.serviceEstimate,
        lastService: r.lastService,
        matchedDate: r.matchedDate,
        customer: r.customer,
        car: r.car,
        dealer: r.dealer,
    };
    return match;
}

// this could also be a private method of the component class
function handleError(error: any) {
    // log error
    // could be something more sofisticated
    let errorMsg =
        error.message ||
        `Yikes! There was was a problem with our hyperdrive device and we couldn't retrieve your data!`;
    console.error(errorMsg);

    // throw an application level error
    return Observable.throw(errorMsg);
}


// WEBPACK FOOTER //
// ./src/app/_services/interval/service-intervals-matches.service.ts